export default "__VITE_ASSET__DbVGv0nW__"